import { useMutation } from "@tanstack/react-query";

import { createSubscriptionService } from "../services/subscriptions";

export const useCreateSubscription = (onSuccess?: (data: any, subscriptionPlanId: number) => void) => {
  return useMutation({
    mutationFn: (subscriptionPlanId: number) => createSubscriptionService(subscriptionPlanId),
    onSuccess: (data, subscriptionPlanId) => {
      if (onSuccess) onSuccess(data, subscriptionPlanId);
    },
  });
};
